import apiClient from '../axiosConfig';

/**
 * Servicio de dashboard
 * Maneja todas las operaciones relacionadas con métricas del dashboard
 * Basado en los endpoints del OpenAPI
 */
class DashboardService {
  /**
   * Obtener total de consultas
   * GET /api/dashboard/consultations/total
   */
  async getTotalConsultations(): Promise<number> {
    const response = await apiClient.get<number>('/dashboard/consultations/total');
    return response.data;
  }

  /**
   * Obtener total de consultas pendientes
   * GET /api/dashboard/consultations/total-pending
   */
  async getTotalPendingConsultations(): Promise<number> {
    const response = await apiClient.get<number>('/dashboard/consultations/total-pending');
    return response.data;
  }

  /**
   * Obtener total de consultas completadas
   * GET /api/dashboard/consultations/total-complete
   */
  async getTotalCompleteConsultations(): Promise<number> {
    const response = await apiClient.get<number>('/dashboard/consultations/total-complete');
    return response.data;
  }

  /**
   * Obtener total de consultas con pago pendiente
   * GET /api/dashboard/consultations/total-pending-payment
   */
  async getTotalPendingPaymentConsultations(): Promise<number> {
    const response = await apiClient.get<number>('/dashboard/consultations/total-pending-payment');
    return response.data;
  }

  /**
   * Obtener todas las métricas del dashboard en una sola llamada
   * Útil para cargar todas las métricas de forma paralela
   */
  async getAllMetrics(): Promise<{
    total: number;
    pending: number;
    complete: number;
    pendingPayment: number;
  }> {
    const [total, pending, complete, pendingPayment] = await Promise.all([
      this.getTotalConsultations().catch(() => 0),
      this.getTotalPendingConsultations().catch(() => 0),
      this.getTotalCompleteConsultations().catch(() => 0),
      this.getTotalPendingPaymentConsultations().catch(() => 0),
    ]);

    return {
      total,
      pending,
      complete,
      pendingPayment,
    };
  }
}

export default new DashboardService();
